import React from "react";
import moment from "moment";
import { UserAuth } from "../../context/AuthContext";

const WelcomeBanner = () => {
  const { user } = UserAuth();

  return (
    <div className="welcome-banner bg-dark-blue-2 border-welcome-banner">
      <div className="w-680">
        <p className="font-18-400-24 text-light-2 "></p>
        <h1 className="font-32-48-400 text-white">
          Welcome back {user?.email ?? ""}
        </h1>
        <p className="text-light font-17-23-400">

        </p>
      </div>
      <div>
        <p className="text-light-2">
          <img src="/calender.svg" className="size-18 mr-2" alt="sps-logo" />
          {moment().format("dddd Do MMMM, YYYY")}
        </p>
      </div>
    </div>
  );
};

export default WelcomeBanner;
